module.exports = __webpack_public_path__ + "carlsberg.png?f7ea3a3330a4c1da7b9ec42d722f84a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carlsberg.png
// module id = 60
// module chunks = 0